// envs
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const shareUrl = process.env.REACT_APP_SHARE_URL;
export const timer = process.env.REACT_APP_RELOAD_SECONDS;
export const collectUrl = process.env.REACT_APP_COLLECT_URL;
